import { customerBaseApi } from "@/react/services/api/api";
import {
  claimableDidsUrl,
  didsBaseUrl,
  dmsCountriesUrl,
} from "@/react/features/smp/dms/urls";

export const didApi = customerBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    retrieveClaimableDids: builder.query({
      query: ({ filterOpts, params }) => ({
        url: claimableDidsUrl,
        method: "POST",
        body: filterOpts,
        params,
      }),
    }),
    retrieveCustomerDids: builder.query({
      query: ({ filterOpts, params }) => ({
        url: didsBaseUrl,
        method: "POST",
        body: filterOpts,
        params,
      }),
    }),
    retrieveDmsCountries: builder.query({
      query: () => ({
        url: dmsCountriesUrl,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useLazyRetrieveClaimableDidsQuery,
  useLazyRetrieveCustomerDidsQuery,
  useLazyRetrieveDmsCountriesQuery,
  useRetrieveDmsCountriesQuery,
} = didApi;
